import { t } from 'i18n';
import React, { useState } from 'react';
import { Dropdown, DropdownMenu, DropdownToggle } from '@teko/ui';
import { useUnreadNotification } from 'hooks';
import dynamic from 'next/dynamic';
import { Badge, Body, styled } from '@teko/ds-desktop';
import { NotificationsOutlined } from '@teko/ds-icon';
import { NavigationButton } from './style';
import { getTrackingData } from '@teko/tracking';
const MiniNotification = dynamic(() =>
  import('components/MiniNotification').then((mod) => mod.MiniNotification),
);
interface NotificationOverviewProps {
  title?: boolean;
}
const StyledDropdown = styled(Dropdown)`
  width: auto;
`;
const WrapperBadge = styled.div`
  position: absolute;
  top: 10px;
  left: calc(50% + 12px);
`;
export const NotificationOverview: React.FC<NotificationOverviewProps> = ({
  title = false,
}: NotificationOverviewProps) => {
  const [openDropdown, setOpenDropdown] = useState(false);
  const { unreadNotification } = useUnreadNotification();
  return (
    <StyledDropdown
      isOpen={openDropdown}
      toggle={() => {
        setOpenDropdown((prev) => !prev);
      }}
      toggleType="hover"
      onHide={(): void => setOpenDropdown(false)}
      {...getTrackingData({
        isTrackContent: true,
        regionName: 'headerBar',
        contentName: 'notificationItem',
        target: 'notification',
      })}
    >
      <DropdownToggle>
        <NavigationButton
          className="button"
          style={{ flexDirection: 'column', minWidth: '68px' }}
        >
          <NotificationsOutlined
            className="noti"
            size={36}
            color="textSecondary"
          />
          {!!unreadNotification && unreadNotification > 0 && (
            <WrapperBadge>
              <Badge count={unreadNotification} />
            </WrapperBadge>
          )}
          {title && (
            <Body
              level={2}
              weight="medium"
              color="textSecondary"
              className="title"
            >
              {t('Thông báo')}
            </Body>
          )}
        </NavigationButton>
      </DropdownToggle>
      <DropdownMenu popperConfig={{ placement: 'bottom-end' }}>
        <MiniNotification onHide={(): void => setOpenDropdown(false)} />
      </DropdownMenu>
    </StyledDropdown>
  );
};
